import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/calculadora")({
  beforeLoad: () => {
    throw redirect({ to: "/herramientas/calculadora", statusCode: 301 });
  },
});
